// src/pages/account/AccountLayout.jsx
import { Outlet, useNavigate } from "react-router-dom";
import Swal, { getApparifyLogoutDialogOptions } from "../../utils/apparifySwal";

import { useAuth } from "../../context/AuthContext";

import { useAccountSwal } from "../../features/account/useAccountSwal";
import AccountSidebar from "../../components/account/AccountSidebar";

export default function AccountLayout() {
  const navigate = useNavigate();
  const { logout } = useAuth();
  const { swalBase, toast } = useAccountSwal();

  const handleLogout = async () => {
    const res = await Swal.fire({
      ...swalBase,
      ...getApparifyLogoutDialogOptions("shopper"),
    });

    if (!res.isConfirmed) return;

    try {
      await logout();

      await toast.fire({
        icon: "success",
        title: "LOGGED OUT",
      });

      navigate("/", { replace: true });
      window.scrollTo({ top: 0, left: 0, behavior: "auto" });
    } catch (err) {
      await Swal.fire({
        ...swalBase,
        icon: "error",
        title: "LOGOUT FAILED",
        html: err?.message || "Something went wrong. Please try again.",
      });
    }
  };

  return (
    <div className="w-full text-neutral-900 dark:text-neutral-50">
      <section className="mb-4 rounded-2xl border border-neutral-200 bg-white p-4 shadow-sm dark:border-neutral-800 dark:bg-neutral-900 sm:p-5">
        <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
          <div className="flex items-center">
            <h1 className="text-xl font-semibold leading-none text-neutral-900 dark:text-neutral-50 sm:text-2xl">
              Settings
            </h1>
          </div>

          <div className="flex flex-col gap-2 sm:flex-row sm:items-center">
            <button
              type="button"
              onClick={() => navigate("/")}
              className="hidden rounded-xl border border-neutral-200 px-3 py-2 text-sm font-semibold text-neutral-700 transition hover:bg-neutral-50 dark:border-neutral-700 dark:text-neutral-200 dark:hover:bg-neutral-800 sm:inline-flex"
            >
              Back to shop
            </button>

            <button
              type="button"
              onClick={handleLogout}
              className="rounded-xl border border-red-200 bg-red-50 px-3 py-2 text-xs font-semibold tracking-[0.20em] text-red-700 transition hover:border-red-300 hover:bg-red-100 hover:text-red-800 dark:border-red-900/60 dark:bg-red-950/30 dark:text-red-300 dark:hover:border-red-800 dark:hover:bg-red-950/50 dark:hover:text-red-200"
            >
              LOGOUT
            </button>
          </div>
        </div>
      </section>

      <div className="flex flex-col gap-4 md:flex-row md:gap-6">
        <AccountSidebar />

        <div className="min-w-0 flex-1">
          <Outlet />
        </div>
      </div>
    </div>
  );
}
